import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'format24HourDatePipe',
    pure: false
})
export class Format24HourDatePipe implements PipeTransform {
    transform(item: number): string {
        if (item === null || item === undefined) {
            return '';
        }
        if ( item === 1100 ) {
            return '11 AM';
        }
        if ( item === 1130 ) {
            return '11:30 AM';
        }
        if ( item === 1200 ) {
            return '12 PM';
        }
        if ( item === 1230 ) {
            return '12:30 PM';
        }
        if ( item === 1300 ) {
            return '1 PM';
        }
        if ( item === 1330 ) {
            return '1:30 PM';
        }
        if ( item === 1400 ) {
            return '2 PM';
        }
        if ( item === 1430 ) {
            return '2:30 PM';
        }
        if ( item === 1500 ) {
            return '3 PM';
        }
        if ( item === 1530 ) {
            return '3:30 PM';
        }
        if ( item === 1600 ) {
            return '4 PM';
        }
        if ( item === 1630 ) {
            return '4:30 PM';
        }
        if ( item === 1700 ) {
            return '5 PM';
        }
        if ( item === 1730 ) {
            return '5:30 PM';
        }
        if ( item === 1800 ) {
            return '6 PM';
        }
        if ( item === 1830 ) {
            return '6:30 PM';
        }
        if ( item === 1900 ) {
            return '7 PM';
        }
        if ( item === 1930 ) {
            return '7:30 PM';
        }
        if ( item === 2000 ) {
            return '8 PM';
        }
        if ( item === 2030 ) {
            return '8:30 PM';
        }
        if ( item === 2100 ) {
            return '9 PM';
        }
        if ( item === 2130 ) {
            return '9:30 PM';
        }
        if ( item === 2200 ) {
            return '10 PM';
        }
        if ( item === 2230 ) {
            return '10:30 PM';
        }
        if ( item === 2300 ) {
            return '11 PM';
        }
        if ( item === 2330 ) {
            return '11:30 PM';
        }
        if ( item === 2400 ) {
            return '12 AM';
        }
        if ( item === 30 ) {
            return '1:30 AM';
        }
        return String(item);
    }
}
